import { hpkeSeal, parsePublicKey } from "../shared/credentials/hpkeFormat";
import { config } from "./environment";
import { emitErrorToast } from "./lib/errorToast";

let sealingKey: string | null | undefined;

class SealingRefusedError extends Error {
  constructor() {
    super("refusing to store a connector secret in plaintext");
    this.name = "SealingRefusedError";
  }
}

export function setSealingKey(key: string | null | undefined) {
  sealingKey = key;
}

export async function sealSecret(plaintext: string): Promise<string> {
  if (sealingKey === undefined) {
    throw new Error("sealing a secret before SignedIn loaded the tenant key");
  }
  if (sealingKey === null) {
    if (config.credentialSealingRequired) {
      emitErrorToast({
        icon: "lock",
        message: "Failed to save the secret. Please reload and try again.",
        buttonLabel: "Dismiss",
      });
      throw new SealingRefusedError();
    }
    return plaintext;
  }
  return hpkeSeal(plaintext, await parsePublicKey(sealingKey));
}

export async function trySealSecret(
  plaintext: string
): Promise<string | undefined> {
  try {
    return await sealSecret(plaintext);
  } catch (error) {
    if (error instanceof SealingRefusedError) return undefined;
    throw error;
  }
}
